import { useMemo } from "react"
import { Data, useDataTypesHooks, useDescribeHooks } from "../../../../../features/data-types"
import { FieldType, Modal, ModalId } from "../../../../../features/ui"
import { useFind } from "../../../../../state/reducers/hooks"
import { TableName } from "../../../../../tables"
import { PaymentTicketItem, Ticket } from "../../../state/types"
import { useAdministrationState } from "../../../hooks/administrationHooks"
import { useTicketHooks } from "../../../hooks/ticketHooks"

type Props = {
    data?: Data
    table: TableName
    paymentTicketItems: PaymentTicketItem[]
    onSubmit: (data: Data) => void
}

export const PartialPaymentModal = (props: Props) => {
    const { data, table, paymentTicketItems, onSubmit } = props

    const { selectedTickets } = useAdministrationState()

    const { getTicketPendingAmount, findParent, isPurchase } = useTicketHooks()
    const { formatValue } = useDataTypesHooks()
    const { describe } = useDescribeHooks()
    const find = useFind()

    const title = `Pago Parcial de Facturas`

    const pendingTickets = useMemo(() =>
        selectedTickets.filter(ticket => !paymentTicketItems.map(item => item.ticketId).includes(ticket.id)),
    [selectedTickets, paymentTicketItems])
    
    const renderBody = () => <>
        Se está efectuando un pago parcial del total de las facturas:<br />
        <ul>
            {paymentTicketItems.map((item, index) => {
                const ticket = find(TableName.TICKETS, item.ticketId)! as Ticket
                const parent = findParent(table, ticket.parentId)!
                const paymentLabel = item.payedAmount === getTicketPendingAmount(ticket) ? 'Pago completo' : 'Pago parcial'
                
                return <li key={index}>
                    {describe(table, parent)} -
                    Vto. {formatValue(new Date(ticket.dueDate), FieldType.DATE)}:
                    <b> {formatValue(item.payedAmount, FieldType.PRICE)} - {paymentLabel}</b>
                </li>
            })}

            {pendingTickets.map((ticket, index) => {
                const parent = findParent(table, ticket.parentId)!
                const paymentLabel = 'Pago pendiente'
                
                return <li key={index}>
                    {describe(table, parent)} -
                    Vto. {formatValue(new Date(ticket.dueDate), FieldType.DATE)}:
                    <b> {formatValue(0, FieldType.PRICE)} - {paymentLabel}</b>
                </li>
            })}
        </ul>
        Deseas confirmar el pago pacial?
    </>

    const handleSubmit = () => {
        data && onSubmit(data)
    }

    return (
        <Modal
            modalId={ModalId.PARTIAL_PAYMENT}
            title={title}
            submitLabel="Confirmar"
            widthSize="m"
            onSubmit={handleSubmit}
        >
            {renderBody()}
        </Modal>
    )
}
